export default __webpack_public_path__ + "static/media/s4img6.1ea7c149.webp";